import config from "./config";
var axios = config();

export default {
  getEmployeeJobs(asuriteId) {
    return axios.get("/api/Employees/GetEmployeeJobs/" + asuriteId);
  },

  getUnsubmittedFaculty(filters, page, pageSize, sortBy, sortDesc) {
    var filter = "";

    if (filters.search) {
      filter += "&search=" + filters.search;
    }
    if (page) {
      filter += "&pageNumber=" + page;
    }
    if (pageSize) {
      filter += "&pageSize=" + pageSize;
    }

    if (sortBy) {
      filter += "&sortBy=" + sortBy + "&sortDesc=" + sortDesc;
    }

    _.forEach(_.keys(filters), key => {
      if (filters[key]) {
        filter += "&" + key + "=" + filters[key];
      }
    });

    return axios.get("/api/Employees/GetUnsubmittedFaculty?" + filter);
  },

  getFaculty() {
    return axios.get("/api/Employees/GetFaculty/");
  },

  getWorkloadFaculty(filters, page, pageSize, sortBy, sortDesc) {
    var filter = "";

    if (filters.search) {
      filter += "&search=" + filters.search;
    }
    if (page) {
      filter += "&pageNumber=" + page;
    }
    if (pageSize) {
      filter += "&pageSize=" + pageSize;
    }

    if (sortBy) {
      filter += "&sortBy=" + sortBy + "&sortDesc=" + sortDesc;
    }

    _.forEach(_.keys(filters), key => {
      if (filters[key]) {
        filter += "&" + key + "=" + filters[key];
      }
    });

    return axios.get("/api/Employees/GetWorkloadFaculty?" + filter);
  },

  getClasses(asurite) {
    return axios.get("/api/employees/" + asurite + "/classes");
  },

  getAwards(asurite) {
    return axios.get("/api/employees/" + asurite + "/awards");
  },

  getProjects(asurite) {
    return axios.get("/api/employees/" + asurite + "/projects");
  },

  getProposals(asurite) {
    return axios.get("/api/employees/" + asurite + "/proposals");
  },

  getCollaborators(asurite) {
    return axios.get("/api/employees/" + asurite + "/collaborators");
  },

  getCommunityPartners(asurite) {
    return axios.get("/api/employees/" + asurite + "/community-partners");
  },

  getTranslationalTeams(asurite) {
    return axios.get("/api/employees/" + asurite + "/translational-teams");
  },

  getExpertise(asurite) {
    return axios.get("/api/employees/" + asurite + "/expertise");
  },

  getByTag(tagId) {
    return axios.get("/api/employees/tag/" + tagId);
  },

  getEmployeeNotes(asuriteId) {
    return axios.get("/api/employees/notes/" + asuriteId);
  },

  postEmployeeNote(note) {
    return axios.post("/api/employees/notes", note);
  }
};
